import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { EventoCalendario } from '../EventoCalendario';
import PermissaoWrapper from '../../../../components/PermissaoWrapper';
import { PermissaoEnum } from '../../../../model/Usuario/Permissao';

interface ModalEditarAtividadeProps {
    show: boolean;
    onHide: () => void;
    onSave: (atividade: EventoCalendario) => void;
    onDelete: (id: string) => void;
    evento?: EventoCalendario | null;
    cronogramaId: string
}

const ModalEditarAtividade: React.FC<ModalEditarAtividadeProps> = ({
    show, onHide, onSave, onDelete, evento, cronogramaId
}) => {
    const [descricao, setDescricao] = useState('');
    const [unidade, setUnidade] = useState('');
    const [lugar, setLugar] = useState('');
    const [hora, setHora] = useState('');
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (show && evento && !isEditing) {
            setDescricao(evento.descricao || '');
            setUnidade(evento.unidade || '');
            setLugar(evento.lugar || '');
            const horaEvento = new Date(evento.start).toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
            });
            setHora(horaEvento);
            setIsEditing(true);
        }
    }, [show, evento, isEditing]);

    useEffect(() => {
        if (!show) {
            setIsEditing(false);
        }
    }, [show]);

    const handleSave = () => {
        if (!hora || !descricao || !unidade || !lugar) {
            alert('Por favor, preencha todos os campos necessários.');
            return;
        }

        const inicio = new Date();
        inicio.setHours(parseInt(hora.split(':')[0]), parseInt(hora.split(':')[1]));
        const fim = new Date(inicio);
        fim.setHours(fim.getHours() + 1);

        const eventoAtualizado: EventoCalendario = {
            title: descricao,
            start: inicio,
            end: fim,
            color: evento?.color || 'hsl(240, 100%, 50%)',
            id: evento?.id ?? 'default-id',
            hora,
            data: evento?.data ?? new Date().toISOString().split('T')[0],
            cronogramaId: cronogramaId,
            unidade,
            descricao,
            lugar,
        };

        onSave(eventoAtualizado);
        onHide();
    };

    const handleDelete = () => {
        if (evento?.id) {
            onDelete(evento.id);
        }
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Atividade</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Descrição</Form.Label>
                        <Form.Control
                            type="text"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Unidade</Form.Label>
                        <Form.Control
                            type="text"
                            value={unidade}
                            onChange={(e) => setUnidade(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Local</Form.Label>
                        <Form.Control
                            type="text"
                            value={lugar}
                            onChange={(e) => setLugar(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Hora</Form.Label>
                        <Form.Control
                            type="time"
                            value={hora}
                            onChange={(e) => setHora(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <PermissaoWrapper permissoesRequiridas={[(PermissaoEnum.DELETAR_ATIVIDADE)]}>
                    <Button variant="danger" onClick={handleDelete}>Excluir</Button>
                </PermissaoWrapper>
                <Button variant="secondary" onClick={onHide}>Cancelar</Button>
                <Button variant="primary" onClick={handleSave}>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalEditarAtividade;
